import * as React from 'react';

export const Loader: React.StatelessComponent = () => {
    return (
        <div>
            <div className="loader-opacity"></div>
            <div className="loader_overlay">
                <div className="loader_wrap">
                    <div className="loading-dots">
                        <h1 className="dot one color9">.</h1><h1 className="dot two color8">.</h1><h1 className="dot three color7">.</h1>
                    </div>

                    <div className="loading-dots">
                        <h1 className="dot one color4">.</h1><h1 className="dot two color5">.</h1><h1 className="dot three color6">.</h1>
                    </div>

                    <div className="loading-dots">
                        <h1 className="dot one color3">.</h1><h1 className="dot two color2">.</h1><h1 className="dot three color1">.</h1>
                    </div>
                </div>
            </div>

        </div>
    )
}



// WEBPACK FOOTER //
// ./src/sharedcomponents/loader.tsx